import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleSearchDto } from '../../vehicles';
import { VehicleRoadTaxRecordCategoryEnum } from '../enums/vehicle-road-tax-record-category.enum';
import { VehicleRoadTaxStatusEnum } from '../enums/vehicle-road-tax-status.enum';

import { VehicleRoadTaxLinksDto } from './vehicle-road-tax-links.dto';

/**
 * Vehicle road tax record DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_ROAD_TAX)
export class VehicleRoadTaxRecordDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleRoadTaxStatusEnum;
  notes?: string | null;
  recordCategory!: VehicleRoadTaxRecordCategoryEnum;
  @TransformInt()
  vehicleId!: number;
  vehicle?: VehicleSearchDto | null;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  tags?: TagListDto[] | null;
  links?: VehicleRoadTaxLinksDto | null;
  files?: FileDto[] | null;
}
